import React, { useEffect, useState, useRef } from "react";
import Images from "../../images";
import { connect } from "react-redux";
import Button from "@mui/material/Button";
import FastForwardRoundedIcon from "@mui/icons-material/FastForwardRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import Lottie from "react-lottie";
import flyingTalk from "../../animations/Flying_Talking.json";
import flyingIdle from "../../animations/Flying_Idle.json";

function WalkThroughIntro(props) {
  const {
    popupVisible,
    walkThroughManual,
    getCurrentWalkThroughStep,
    onTourComplete,
    onTourRestart,
    currentOSName,
  } = props;
  let msg = new SpeechSynthesisUtterance();
  let walkthroughData = [
    {
      step: 0,
      stepHeaderText: "Header",
      stepText:
        "Here you will complete the exercises assigned to you in an engaging and interactive manner. But first, would you like a short tutorial on how to use the platform?",
    },
    {
      step: 1,
      stepHeaderText: "Hey It's me!",
      stepText:
        "My name is Knova Bot and I'm your assistant in this platform. I will be guiding you through this tutorial. You can also click on me to access different functions such as help and instructions for questions.",
    },
    {
      step: 2,
      stepHeaderText: "Navigation buttons",
      stepText:
        "This is your main navigation between activities. You can navigate from one activity to another using the left and right buttons shown above.",
    },
    {
      step: 3,
      stepHeaderText: "Submit and Reset",
      stepText:
        "Here are the submit and reset buttons. Clicking the reset button will remove all existing student user input, and will require the user to rework the entire lesson. Clicking the submit button will complete the activity and send it to your teacher.",
    },
    {
      step: 4,
      stepHeaderText: "Drawing and Audio tools",
      stepText:
        "This is where you will access the drawing and audio tools including Drawing tools and audio tools. You can also click the select button, in order to select and move or delete existing strokes.",
    },
    {
      step: 5,
      stepHeaderText: "Pencil settings",
      stepText:
        "This is where you can set up the width of the pen tip and also the color of the pen tip.",
    },
    {
      step: 6,
      stepHeaderText: "Shape settings",
      stepText:
        "This is where you pick the shapes option instead of the Pen settings. There are three shapes available - Circle, rectangle and line. In order to delete or manipulate the shapes, you will need to click the Select button, and then either move the shape, resize or delete the shape.",
    },
    {
      step: 7,
      stepHeaderText: "Select strokes",
      stepText:
        "This is where you hit the Select button in order to select strokes and shapes.",
    },

    {
      step: 8,
      stepHeaderText: "Voice Record",
      stepText:
        "This is where you can add any voice notes relating to this whole activity.",
    },
    {
      step: 9,
      stepHeaderText: "Strokes replay",
      stepText:
        "This is where you have a built-in replay mechanism for every replay rectangle.",
    },
    {
      step: 10,
      stepHeaderText: "And that's a wrap!",
      stepText:
        "And that’s a wrap! If you need more help, just click on me. I am available 24 by 7!! Cheers!",
    },
  ];

  const [currentWalkThroughStep, setCurrentWalkThroughStep] = useState(0);
  const [currentWalkThroughStepArray, setCurrentWalkThroughStepArray] =
    useState([]);
  const [currentLineNumber, setCurrentLineNumber] = useState(-1);
  const [isTalking, setIsTalking] = useState(false);

  const handlePopupOk = () => {
    setCurrentWalkThroughStep(
      (currentWalkThroughStep) => currentWalkThroughStep + 1
    );
  };

  useEffect(() => {
    if (walkThroughManual) {
      setCurrentWalkThroughStep(1);
    }
  }, [walkThroughManual]);

  useEffect(() => {
    window.speechSynthesis.cancel();
    getCurrentWalkThroughStep(currentWalkThroughStep);
    if (currentWalkThroughStep > 0) {
      setTimeout(() => {
        if (walkthroughData[currentWalkThroughStep]) {
          let splitedText =
            walkthroughData[currentWalkThroughStep].stepText.split(". ");
          setCurrentWalkThroughStepArray(splitedText);
        }
      }, 1000);
    }
  }, [currentWalkThroughStep]);

  useEffect(() => {
    if (currentWalkThroughStepArray.length > 0) {
      setCurrentLineNumber(0);
    }
  }, [currentWalkThroughStepArray]);

  useEffect(() => {
    if (
      currentWalkThroughStepArray[currentLineNumber] &&
      currentWalkThroughStep[currentLineNumber] !== ""
    ) {
      speakWarningOrSuccess(currentWalkThroughStepArray[currentLineNumber]);
    } else {
      setIsTalking(false);
    }
  }, [currentLineNumber]);

  function speakWarningOrSuccess(text) {
    window.speechSynthesis.onvoiceschanged = (event) => {
      console.log("voicesChanged");
    };
    setTimeout(() => {
      // setIsWarningBotTalking(true);
      setIsTalking(true);
      let voices = window.speechSynthesis.getVoices();
      if (currentOSName === "Chrome OS") {
        for (let index = 0; index < voices.length; index++) {
          //Google UK English Female
          if (voices[index].voiceURI === "Chrome OS US English 8") {
            msg.voice = voices[index];
            msg.voiceURI = "Chrome OS US English 8";
            msg.volume = 1;
            msg.rate = 0.8;
            msg.pitch = 0.9;
            msg.text = text;
            msg.lang = "en-US";
            msg.onend = function () {
              setCurrentLineNumber(
                (currentLineNumber) => currentLineNumber + 1
              );
              //setIsWarningBotTalking(false);
            };
            // msg.addEventListener('boundary', (event) => {
            //   console.log('event', event)
            // })
            window.speechSynthesis.speak(msg);
          }
        }
      } else {
        for (let index = 0; index < voices.length; index++) {
          //Google UK English Female
          if (voices[index].voiceURI === "Google US English") {
            msg.voice = voices[index];
            msg.voiceURI = "Google US English";
            msg.volume = 1;
            msg.rate = 0.8;
            msg.pitch = 0.9;
            msg.text = text;
            msg.lang = "en-US";
            msg.onend = function () {
              setCurrentLineNumber(
                (currentLineNumber) => currentLineNumber + 1
              );
              //setIsWarningBotTalking(false);
            };
            // msg.addEventListener('boundary', (event) => {
            //   console.log('event', event)
            // })
            window.speechSynthesis.speak(msg);
          }
        }
      }
    }, 100);
  }

  const knovoTalkingAnime = {
    loop: true,
    autoplay: true,
    animationData: flyingTalk,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const knovoIdleAnime = {
    loop: true,
    autoplay: true,
    animationData: flyingIdle,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  function renderTalkingAnime() {
    return (
      <div
        style={{
          width: "100%",
          objectFit: "contain",
          height: "100%",
        }}
      >
        <Lottie
          options={knovoTalkingAnime}
          width="100%"
          isStopped={false}
          style={{
            justifyContent: "center",
            alignSelf: "center",
            height: undefined,
          }}
        />
      </div>
    );
  }

  function renderIdleAnime() {
    return (
      <div
        style={{
          width: "100%",
          objectFit: "contain",
          height: "100%",
        }}
      >
        <Lottie
          options={knovoIdleAnime}
          width="100%"
          isStopped={false}
          style={{
            justifyContent: "center",
            alignSelf: "center",
            height: undefined,
          }}
        />
      </div>
    );
  }

  if (popupVisible) {
    return (
      <div className="walkthrough-main-container">
        {currentWalkThroughStep === 0 ? (
          <div className="walkthrough-intro-container">
            <img src={Images.login_image} alt="logo" style={{ width: "40%" }} />
            <span className="walkthrough-KnomadixBackpack">
              Knomadix<span className="walkthrough-text-style-1">Backpack</span>
            </span>
            <div className="walkthrough-intro-message">
              <p className="walkthrough-text-style-2">
                Here you will complete the exercises assigned to you in an
                engaging and interactive manner.
              </p>
              <p className="walkthrough-text-style-3">
                But first, would you like a short tutorial on how to use the
                platform?
              </p>
              <Button
                variant="contained"
                style={{
                  height: "44px",
                  backgroundColor: "#FF9E2D",
                  borderRadius: "8px",
                  marginTop: "10%",
                  color: "#000000",
                  fontSize: "14px",
                }}
                onClick={() => {
                  handlePopupOk();
                }}
              >
                Yes, Show me how
              </Button>
              <Button
                variant="outlined"
                style={{
                  height: "44px",
                  width: "134px",
                  color: "#000000",
                  borderColor: "#EAEAEA",
                  marginTop: "5%",
                  marginBottom: "10%",
                }}
                onClick={() => {
                  onTourComplete();
                }}
              >
                Skip
              </Button>
            </div>
          </div>
        ) : (
          <div
            className="walkthrough-step-container"
            style={{
              animationName:
                walkthroughData[currentWalkThroughStep].step === 2
                  ? "tourAnim2"
                  : walkthroughData[currentWalkThroughStep].step === 3
                  ? "tourAnim3"
                  : walkthroughData[currentWalkThroughStep].step === 4
                  ? "tourAnim4"
                  : walkthroughData[currentWalkThroughStep].step === 5 ||
                    walkthroughData[currentWalkThroughStep].step === 8
                  ? "tourAnim5"
                  : walkthroughData[currentWalkThroughStep].step === 7
                  ? "tourAnim7"
                  : walkthroughData[currentWalkThroughStep].step === 10
                  ? "tourAnim10"
                  : "none",
              animationDuration: "1s",
              top:
                walkthroughData[currentWalkThroughStep].step === 1
                  ? "38%"
                  : walkthroughData[currentWalkThroughStep].step === 2 ||
                    walkthroughData[currentWalkThroughStep].step === 3
                  ? 0
                  : undefined,
              bottom:
                walkthroughData[currentWalkThroughStep].step === 5 ||
                walkthroughData[currentWalkThroughStep].step === 6 ||
                walkthroughData[currentWalkThroughStep].step === 8 ||
                walkthroughData[currentWalkThroughStep].step === 9
                  ? "22%"
                  : walkthroughData[currentWalkThroughStep].step === 1 ||
                    walkthroughData[currentWalkThroughStep].step === 2 ||
                    walkthroughData[currentWalkThroughStep].step === 3
                  ? undefined
                  : walkthroughData[currentWalkThroughStep].step === 4 ||
                    walkthroughData[currentWalkThroughStep].step === 7
                  ? "15%"
                  : "10%",
              right:
                walkthroughData[currentWalkThroughStep].step === 1
                  ? undefined
                  : walkthroughData[currentWalkThroughStep].step === 2
                  ? "50%"
                  : walkthroughData[currentWalkThroughStep].step === 3
                  ? "10%"
                  : walkthroughData[currentWalkThroughStep].step === 4 ||
                    walkthroughData[currentWalkThroughStep].step === 5 ||
                    walkthroughData[currentWalkThroughStep].step === 6 ||
                    walkthroughData[currentWalkThroughStep].step === 7 ||
                    walkthroughData[currentWalkThroughStep].step === 8 ||
                    walkthroughData[currentWalkThroughStep].step === 9
                  ? "30%"
                  : "10%",
              left:
                walkthroughData[currentWalkThroughStep].step === 1
                  ? "48%"
                  : undefined,
              zIndex:
                walkthroughData[currentWalkThroughStep].step === 1 ? 3 : 0,
            }}
          >
            <div
              className="walkthrough-step-main"
              style={{
                zIndex:
                  walkthroughData[currentWalkThroughStep].step === 1 ? 3 : 0,
              }}
            >
              <div className="walkthrough-step-header">
                <p className="walkthrough-header-text">
                  {walkthroughData[currentWalkThroughStep].stepHeaderText}
                </p>
                {currentWalkThroughStep < 10 && (
                  <div
                    className="header-circle-button-close"
                    style={{
                      width: "26px",
                      height: "23px",
                      backgroundColor: "#ffffff",
                    }}
                    onClick={() => {
                      setCurrentLineNumber(-1);
                      setCurrentWalkThroughStep(
                        (currentWalkThroughStep) => currentWalkThroughStep + 1
                      );
                    }}
                  >
                    <FastForwardRoundedIcon
                      style={{
                        height: "15px",
                        width: "15px",
                        color: "#6644FF",
                      }}
                    />
                  </div>
                )}
                {currentWalkThroughStep < 10 && (
                  <CancelRoundedIcon
                    style={{
                      height: "25px",
                      width: "25px",
                      color: "#ffffff",
                      marginLeft: "5px",
                    }}
                    onClick={() => {
                      window.speechSynthesis.cancel();
                      onTourComplete();
                    }}
                  />
                )}
              </div>
              <div className="walkthrough-step-message">
                <p className="walkthrough-message-text">
                  {walkthroughData[currentWalkThroughStep].stepText}
                </p>
                {currentWalkThroughStep === 10 && (
                  <div className="walkthrough-button-style">
                    <Button
                      variant="contained"
                      style={{
                        height: "44px",
                        width: "134px",
                        backgroundColor: "#FFC42D",
                        borderRadius: "8px",
                        marginRight: "20px",
                        color: "#000000",
                      }}
                      onClick={() => {
                        window.speechSynthesis.cancel();
                        onTourComplete();
                      }}
                    >
                      Done
                    </Button>
                    <Button
                      variant="outlined"
                      style={{
                        height: "44px",
                        width: "134px",
                        borderColor: "#EAEAEA",
                        color: "#000000",

                        borderRadius: "8px",
                      }}
                      onClick={() => {
                        setCurrentWalkThroughStep(1);
                      }}
                    >
                      Go again
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {currentWalkThroughStep > 0 && (
          <div
            className="walkthrough-bot-container"
            style={{
              animationName:
                walkthroughData[currentWalkThroughStep].step === 2
                  ? "tourBotAnim2"
                  : walkthroughData[currentWalkThroughStep].step === 3
                  ? "tourBotAnim3"
                  : walkthroughData[currentWalkThroughStep].step === 4
                  ? "tourBotAnim4"
                  : walkthroughData[currentWalkThroughStep].step === 5
                  ? "tourBotAnim5"
                  : walkthroughData[currentWalkThroughStep].step === 6
                  ? "tourBotAnim6"
                  : walkthroughData[currentWalkThroughStep].step === 7
                  ? "tourBotAnim7"
                  : walkthroughData[currentWalkThroughStep].step === 10
                  ? "tourBotAnim10"
                  : "none",
              animationDuration: "2s",
              animationTimingFunction: "linear",
              animationFillMode: "forwards",
              backgroundColor:
                walkthroughData[currentWalkThroughStep].step === 1
                  ? "lightgray"
                  : "",
              borderRadius: "10px",
              top:
                walkthroughData[currentWalkThroughStep].step === 1
                  ? "20%"
                  : walkthroughData[currentWalkThroughStep].step === 2 ||
                    walkthroughData[currentWalkThroughStep].step === 3
                  ? "10%"
                  : undefined,
              bottom:
                walkthroughData[currentWalkThroughStep].step === 5 ||
                walkthroughData[currentWalkThroughStep].step === 6 ||
                walkthroughData[currentWalkThroughStep].step === 8 ||
                walkthroughData[currentWalkThroughStep].step === 9
                  ? "20%"
                  : walkthroughData[currentWalkThroughStep].step === 1 ||
                    walkthroughData[currentWalkThroughStep].step === 2 ||
                    walkthroughData[currentWalkThroughStep].step === 3
                  ? undefined
                  : walkthroughData[currentWalkThroughStep].step === 4 ||
                    walkthroughData[currentWalkThroughStep].step === 7
                  ? "10%"
                  : "10%",
              right:
                walkthroughData[currentWalkThroughStep].step === 1
                  ? undefined
                  : walkthroughData[currentWalkThroughStep].step === 2
                  ? "42%"
                  : walkthroughData[currentWalkThroughStep].step === 3
                  ? "28%"
                  : walkthroughData[currentWalkThroughStep].step === 4 ||
                    walkthroughData[currentWalkThroughStep].step === 6
                  ? "24%"
                  : walkthroughData[currentWalkThroughStep].step === 5 ||
                    walkthroughData[currentWalkThroughStep].step === 7 ||
                    walkthroughData[currentWalkThroughStep].step === 8 ||
                    walkthroughData[currentWalkThroughStep].step === 9
                  ? "48%"
                  : "2%",
              left:
                walkthroughData[currentWalkThroughStep].step === 1
                  ? "40%"
                  : undefined,
              zIndex: 2,
            }}
          >
            {isTalking ? renderTalkingAnime() : renderIdleAnime()}
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(WalkThroughIntro);
